import { signal } from '@preact/signals';
import type { MeteorService } from './live/meteors';
import type { SatelliteService } from './live/satellites';
import type { SmallBodyService } from './live/smallbodies';
import type { SkyEngine } from './render/engine';

/** Live services, available once the sky has loaded. */
export interface AppServices {
  engine: SkyEngine;
  sats: SatelliteService;
  meteors: MeteorService;
  small: SmallBodyService;
}

export const services = signal<AppServices | null>(null);
export const svc = () => services.peek();
